<template>
    <div>
        <b-row>
            <b-col md="8" lg="8">
                <b-form-group
                    :label="productNameLabel"
                    label-for="name"
                >
                    <b-form-input
                        id="name"
                        class="input-bg-warning"
                        v-model="name"
                        :state="nameState"
                        @input="emit"
                    />
                </b-form-group>
            </b-col>
            <b-col>
                <h6>{{ $t('Page(ReceivedRequest):Component(Text):product-name-in-request') }}</h6>
                <span>{{ customerProduct.name }}</span>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="8" lg="8">
                <b-form-group
                    :label="productIdLabel"
                    label-for="id"
                >
                    <b-form-input
                        id="id"
                        v-model="id"
                        @input="emit"
                    />
                </b-form-group>
            </b-col>
            <b-col>
                <h6>{{ $t('Page(ReceivedRequest):Component(Text):product-id-in-request') }}</h6>
                <span>{{ customerProduct.identifier }}</span>
            </b-col>
        </b-row>
        <ProductMaterialMixtureCategorySelector
            v-if="showMaterialMixtureCategorySelector"
            :material-category-ids="product.materialCategoryIds || []"
            :mixture-category-ids="product.mixtureCategoryIds || []"
            @change="onMaterialMixtureCategoryChange"
        />
    </div>
</template>

<script>
import {BFormInput, BFormGroup, BCol, BRow} from 'bootstrap-vue'
import ReplyTabProductSection from "@core/mixins/ui/reply-tab-product-section";
import ProductCategoryTagView from "@core/components/product/ProductCategoryTagView";
import {setNameOrId, ProductNames, ProductIdentifiers, ProductType} from "@/libs/product";
import ProductMaterialMixtureCategorySelector from '@/views/product/components/product-card/common/categories';

export default {
    mixins: [ReplyTabProductSection],
    components: {
        BFormInput, BFormGroup, BCol, BRow, ProductCategoryTagView, ProductMaterialMixtureCategorySelector,
    },
    props: {
        product: {
            required: true,
        },
        request: {
            required: true,
        },
        customerProduct: {
            required: true
        },
        includedSubstances: {
            type: Array,
            default() {
                return [];
            }
        },
        showMaterialMixtureCategorySelector: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            name: this.getProductName(this.product.names, this.resolveProductNameKey()),
            id: this.getProductId(this.product.identifiers, this.resolveProductIdentifierKey()),

            selected: [
                { title: 'Square' },
                { title: 'Romboid' },
            ],

            type: ProductType.UNDEFINED,
            typeOwn: ProductType.OWN,
            typePurchased: ProductType.PURCHASED_UNDEFINED_SUPPLIER,

            hierarchy: {children: []},
        };
    },
    methods: {
        emit() {
            setNameOrId(
                this.product.names,
                this.resolveProductNameKey(),
                this.name
            );
            setNameOrId(
                this.product.identifiers,
                this.resolveProductIdentifierKey(),
                this.id
            );

            this.$emit('change');
            this.emitValidity();
        },

        resolveProductNameKey() {
            return ProductNames.OUR_PRODUCT_NAME;
        },

        resolveProductIdentifierKey() {
            return ProductIdentifiers.PRODUCT_ID;
        },

        isInformationValid() {
            if (!this.name) {
                return false;
            }

            if (this.showMaterialMixtureCategorySelector && !this.hasMaterialOrMixtureCategory()) {
                return false;
            }

            return true;
        },

        hasMaterialOrMixtureCategory() {
            return (this.product.materialCategoryIds || []).length > 0
                || (this.product.mixtureCategoryIds || []).length > 0;
        },

        emitValidity() {
            this.$emit('validityChanged', this.isInformationValid());
        },

        populateNameAndIdentifier() {
            this.name = this.getProductName(this.product.names, this.resolveProductNameKey());
            this.id = this.getProductId(this.product.identifiers, this.resolveProductIdentifierKey());
        },

        onMaterialMixtureCategoryChange({ materialCategoryIds, mixtureCategoryIds }) {
            this.$set(this.product, 'materialCategoryIds', materialCategoryIds);
            this.$set(this.product, 'mixtureCategoryIds', mixtureCategoryIds);
            this.$emit('change');
            this.emitValidity();
        }
    },
    computed: {
        nameState() {
            return this.name !== undefined && this.name !== '' && this.name.length > 1;
        },

        productNameLabel() {
            return this.getNameLabel(this.resolveProductNameKey());
        },

        productIdLabel() {
            return this.getIdentifierLabel(this.resolveProductIdentifierKey());
        },

        productType() {
            return this.product.type;
        },
    },

    watch: {
        productType() {
            this.populateNameAndIdentifier();
        },
        product(p) {
            this.type = this.product.type;

            this.populateNameAndIdentifier();
            this.emitValidity();
        },
        request() {
            this.emitValidity();
        }
    }
}
</script>
